/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.segment.rpc.SegmentSnapshotRpc
 */

/**
 *  Represents a segment identifier, which is an immutable identifier for a segment.
 *  It contains the segment type and the implementation object ID.
 *  Ideally you should never construct a {@link SegmentIdentifier} directly, and should treat it as indivisible unit, using only identifiers you receive from Segment APIs.
 */

export const buildSnapshotRpc = {
  serviceName: 'com.hubspot.segment.rpc.SegmentSnapshotRpc',
  rpcName: 'buildSnapshot',
  auth: 'app',
  fingerprint: 'e6ZzdUqgtnvYbyTjT3hhUxDXwXcckRB3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const buildSnapshotForInputRpc = {
  serviceName: 'com.hubspot.segment.rpc.SegmentSnapshotRpc',
  rpcName: 'buildSnapshotForInput',
  auth: 'app',
  fingerprint: 'B-lVV2QBsU_YbyTjT3hhUxDXwXcckRB3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const buildSnapshotForInput2Rpc = {
  serviceName: 'com.hubspot.segment.rpc.SegmentSnapshotRpc',
  rpcName: 'buildSnapshotForInput2',
  auth: 'app',
  fingerprint: 'BmG7PRQUlsDYbyTjT3hhUxDXwXcckRB3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const purgeSnapshotsRpc = {
  serviceName: 'com.hubspot.segment.rpc.SegmentSnapshotRpc',
  rpcName: 'purgeSnapshots',
  auth: 'app',
  fingerprint: 'cr8GkUtI_UJ9rma-Sep2VRDXwXcckRB3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};